import { Flex, Text } from '@mantine/core';

import styles from './RingProgress.module.css';

export const LBRingProgress = ({ value }: { value: number }) => {
  const color = () => {
    if (value === 100) return '#5ECE7B';
    if (value >= 50) return '#E89E10';
    return '#92949F';
  };

  return (
    <Flex align='center' gap={4}>
      <Text c={color()} fz={12} lh={1}>
        {value} %
      </Text>
      <div className={styles.circle} style={{ borderColor: color() }} />
    </Flex>
  );
};
